import {merge} from 'lodash-es';
import {BaseOctopusConfig} from '../../../../base.octopus-config';
import {defaultApiURL} from '../../../../src/app/settings/cycle-1-tne-canope';

const overrideConfig = {
    configuration: {
        http: {
            apiUrl: defaultApiURL,
        }
    }
}

export const Cycle1TneCanopeOctopusConfig = merge({}, BaseOctopusConfig, overrideConfig);